import { dateformat } from '../../components/common/Helpers'
import AvatarImage from '../../components/common/ui/avatars/AvatarImage'
import AvatarPlaceholder from '../../components/common/ui/avatars/AvatarPlaceholder'
import FlowerSvg from '../../components/common/ui/assets/FlowerSvg'

export default function ObituaryItem({ obituary, photoShape, target, showFlowersIcon }) {

    return (
        <div className="relative rounded-lg border bg-white px-6 py-5 shadow-lg flex-col md:flex-row flex md:space-x-6 text-center md:text-left obituary-item obituary-full-item">
            <div className="shrink-0">
                <a href={obituary.public_url} target={target}>
                    {obituary.default_image_sizes
                        ? <AvatarImage url={obituary.default_image_sizes.sm} className={"object-cover obituary-photo obituary-full-photo mx-auto md:ml-x"} ring={false} round={photoShape == 'circle'} size={48} />
                        : <AvatarPlaceholder className={"obituary-photo obituary-full-photo"} round={photoShape == 'circle'} size={48} />
                    }
                </a>
            </div>
            <div className="flex-1 min-w-0 px-1 md:px-0">
                <p className="text-3xl font-medium text-gray-900 obituary-name obituary-full-name mt-3 md:mt-0">
                    <a href={obituary.public_url} target={target}>{obituary.display_name}</a>
                </p>
                {obituary.date_of_death !== null && obituary.show_date_of_death &&
                    <p className="text-xl text-gray-500 obituary-date obituary-full-date mt-1">{dateformat(obituary.date_of_death)}</p>
                }
                <div className="obituary-text obituary-full-text mt-3" dangerouslySetInnerHTML={{ __html: obituary.obituary_text_preview }} />

                <div className="mt-3 flex space-x-4 justify-center md:justify-start">
                    <a href={obituary.public_url} target={target} className="px-4 py-2 rounded-full bg-blue-600 text-white obituary-visit-button obituary-full-visit-button">
                        Visit Obituary
                    </a>
                    <a href={obituary.flower_sales_url} target={target} className="flex items-center justify-center px-4 py-2 border rounded-full border-blue-600 text-blue-600 obituary-flowers-button obituary-full-flowers-button">
                        {showFlowersIcon === 'true' && <FlowerSvg />}
                        <p className={`${showFlowersIcon === 'true' && 'ml-2'} obituary-flowers-text obituary-full-flowers-text`}>Send Flowers</p>
                    </a>
                </div>
            </div>
        </div>
    )
}
